import bugsnag, { Client as IBugsnagClient } from 'bugsnag-js';
import { IConfig as IBugsnagOptions } from 'bugsnag-js/types/common';

export class ErrorReporter {
  private bugsnagClient: IBugsnagClient;

  constructor(options: IBugsnagOptions) {
    this.bugsnagClient = bugsnag(options);
  }

  public setUser(user: object) {
    this.bugsnagClient.user = user;
  }

  public notify(err: Error) {
    this.bugsnagClient.notify(err);
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/infrastructure/adapter/ErrorReporter.ts